import React from 'react';
import { Section } from './Section';
import { CTAButton } from '../CTAButton';
import { karitoPhoto } from '../../data/content';
export function About() {
  return <Section tone="white" data-id="element-57" data-mp="oti39f31ew6h">
      <h2 className="text-center font-display text-[1.7rem] font-bold leading-tight text-navy sm:text-4xl" data-id="element-58" data-mp="12rf44noixoqy">
        About Dr. Karito
      </h2>

      <div className="mt-7 overflow-hidden rounded-3xl border border-navy/10 bg-cream" data-id="element-59" data-mp="yptmkp11omaf">
        <img src={karitoPhoto} alt="Dr. Karito, creator of the Menopause Clinical Blueprint" className="h-72 w-full object-cover object-top sm:h-96" data-id="element-60" data-mp="b0inrd3991yx" />
        <div className="p-5 sm:p-6" data-id="element-61" data-mp="jt2pwnir9ooi">
          <p className="text-[15px] font-semibold leading-snug text-navy" data-id="element-62" data-mp="ju5g0t897n3d">
            The Menopause Clinical Blueprint™ was created to solve one of the
            biggest challenges physicians face: turning evidence into confident
            clinical decisions.
          </p>
          <p className="mt-3 text-[14.5px] leading-relaxed text-navy/70" data-id="element-63" data-mp="3jf10vt81z7pe">
            Today's guidelines are excellent—but they're often lengthy,
            fragmented and difficult to apply during a busy clinic day.
          </p>
          <p className="mt-3 text-[14.5px] leading-relaxed text-navy/70" data-id="element-64" data-mp="3cz1pv444k64l">
            Dr. Karito developed a structured clinical framework that transforms
            the latest international recommendations into practical, step-by-step
            decision pathways physicians can use immediately.
          </p>
          <p className="mt-4 border-l-4 border-gold pl-4 font-display text-lg font-bold leading-snug text-navy" data-id="element-65" data-mp="2p97cmlfw8fjt">
            The goal isn't simply to learn more. It's to make better clinical
            decisions with greater confidence.
          </p>
        </div>
      </div>

      <CTAButton className="mt-8" variant="navy" label="Get Dr. Karito's clinical system" subline="$27 today • Lifetime access" data-id="element-66" data-mp="2z5afjtikki7t" />
    </Section>;
}